import { render, staticRenderFns } from "./RegisterClient.vue?vue&type=template&id=177a34de&scoped=true"
import script from "./RegisterClient.vue?vue&type=script&lang=js"
export * from "./RegisterClient.vue?vue&type=script&lang=js"
import style0 from "./RegisterClient.vue?vue&type=style&index=0&id=177a34de&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a34de",
  null
  
)

export default component.exports